import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';


/* Screens Import */
import WelcomeScreen from '../../CommonScreens/WelcomeScreen/WelcomeScree';
import Frame51 from '../../Episode3/Frame51/Frame51';
import Frame52 from '../../Episode3/Frame52/Frame52';
import Frame53 from '../../Episode3/Frame53/Frame53';
import Frame54 from '../../Episode3/Frame54/Frame54';
import Frame55 from '../../Episode3/Frame55/Frame55';
import Frame56 from '../../Episode3/Frame56/Frame56';
import Frame57 from '../../Episode3/Frame57/Frame57';
import Frame58 from '../../Episode3/Frame58/Frame58';
import Frame59 from '../../Episode3/Frame59/Frame59';
import Frame60 from '../../Episode3/Frame60/Frame60';
import Frame61 from '../../Episode3/Frame61/Frame61';
import Frame62 from '../../Episode3/Frame62/Frame62';
import Frame63 from '../../Episode3/Frame63/Frame63';
import Frame64 from '../../Episode3/Frame64/Frame64';
import Frame65 from '../../Episode3/Frame65/Frame65';
import Frame66 from '../../Episode3/Frame66/Frame66';
import Frame67 from '../../Episode3/Frame67/Frame67';
import Frame68 from '../../Episode3/Frame68/Frame68';
import Frame69 from '../../Episode3/Frame69/Frame69';



function Episode2_MainPage() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);

    if (pageNo === 55) {
        return (
            <div>
                <WelcomeScreen />
            </div>
        )
    } else if (pageNo === 56) {
        return (
            <div>
                <Frame51 />
            </div>
        )
    } else if (pageNo === 57) {
        return (
            <div>
                <Frame52 />
            </div>
        )
    } else if (pageNo === 58) {
        return (
            <div>
                <Frame53 />
            </div>
        )
    } else if (pageNo === 59) {
        return (
            <div>
                <Frame54 />
            </div>
        )
    } else if (pageNo === 60) {
        return (
            <div>
                <Frame55 />
            </div>
        )
    } else if (pageNo === 61) {
        return (
            <div>
                <Frame56 />
            </div>
        )
    } else if (pageNo === 62) {
        return (
            <div>
                <Frame57 />
            </div>
        )
    } else if (pageNo === 63) {
        return (
            <div>
                <Frame58 />
            </div>
        )
    } else if (pageNo === 64) {
        return (
            <div>
                <Frame59 />
            </div>
        )
    } else if (pageNo === 65) {
        return (
            <div>
                <Frame60 />
            </div>
        )
    } else if (pageNo === 66) {
        return (
            <div>
                <Frame61 />
            </div>
        )
    } else if (pageNo === 67) {
        return (
            <div>
                <Frame62 />
            </div>
        )
    } else if (pageNo === 68) {
        return (
            <div>
                <Frame63 />
            </div>
        )
    } else if (pageNo === 69) {
        return (
            <div>
                <Frame64 />
            </div>
        )
    } else if (pageNo === 70) {
        return (
            <div>
                <Frame65 />
            </div>
        )
    } else if (pageNo === 71) {
        return (
            <div>
                <Frame66 />
            </div>
        )
    } else if (pageNo === 72) {
        return (
            <div>
                <Frame67 />
            </div>
        )
    } else if (pageNo === 73) {
        return (
            <div>
                <Frame68 />
            </div>
        )
    } else if (pageNo === 74) {
        return (
            <div>
                <Frame69 />
            </div>
        )
    } 
}

export default Episode2_MainPage